export default defineAppConfig({
  b24ui: {},
  colorMode: true,
  colorModeTypeLight: 'light' as const
})
